import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 261.76 226.69"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#41b883",
      d: "m161.096.001-30.224 52.35L100.647.002H-.005L130.872 226.69 261.749 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#34495e",
      d: "m161.096.001-30.224 52.35L100.647.002H52.346l78.526 136.01L209.398.001z"
    }, null, -1)
  ])))
}
export default { render: render }